import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-RegisteredDomesticPartners',
    templateUrl: './RegisteredDomesticPartners.component.html',
    styleUrls: ['./RegisteredDomesticPartners.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegisteredDomesticPartnersComponent implements OnInit, AfterViewInit {

  id: number;
  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }

  ngAfterViewInit() {
    console.log(this.id);
  }
  ngOnInit() {
  }

}
